<template>
  <div class="btn-group-sm action-btn-group d-flex align-items-center action-btn-container">
    <video-btn class="mr-4 mr-md-2 position-relative" :forVideo="true" v-bind="$props" v-if="shiurim.length != '00:00' && hasVideo"></video-btn>
    <play-btn class="mr-4 mr-md-2 position-relative" :forVideo="false" v-bind="$props" v-if="shiurim.length != '00:00' && hasAudio"></play-btn>
    <download-btn class="mr-4 mr-md-2 position-relative" v-bind="$props" :hide-text="hideText" v-if="shiurim.url_download"></download-btn>
    <mm-btn class="position-relative" v-if="shiurim.notes_file && shiurim.type === 'shas'" v-bind="$props" :hide-text="hideText"></mm-btn>
    <mm-mishna-btn class="position-relative" v-if="shiurim.notes_file && shiurim.type === 'mishna'" v-bind="$props" :hide-text="hideText"></mm-mishna-btn>
  </div>
</template>
<script>
import playBtnComponent from './ActionButtons/playBtn.vue';
import videoBtnComponent from './ActionButtons/videoBtn.vue';
import downloadBtnComponent from './ActionButtons/downloadBtn.vue';
import mmBtnComponent from './ActionButtons/mmBtn.vue';
import mmMishnaBtnComponent from './ActionButtons/mmMishnaBtn.vue';

export default {
  components: {
    playBtn: playBtnComponent,
    videoBtn: videoBtnComponent,
    downloadBtn: downloadBtnComponent,
    mmBtn: mmBtnComponent,
    mmMishnaBtn: mmMishnaBtnComponent,
  },
  props: ['magidShiur', 'shiurim', 'type', 'hideText'],
  computed: {
    hasAudio: function () {
      var url = this.shiurim.url_preview || this.shiurim.url_download;
      return url && url != '';
    },
    hasVideo: function () {
      var url = this.shiurim.url_video_preview || this.shiurim.url_video_download;
      return url && url != '';
    },
  },
};
</script>

<style lang="scss">
.action-btn-group {
  min-width: 160px;
  @media (max-width: 576px) {
    justify-content: center;
  }
}
</style>
